module.exports = __webpack_public_path__ + "static/media/IMG_1522.ad1414d6.jpg";